import request from '@/utils/request';

// 查询员工
export function listStaff(query) {
  return request({
    url: '/staff/list',
    method: 'get',
    params: query,
  });
}

// 新增员工
export function addStaff(data) {
  return request({
    url: '/staff/add',
    method: 'post',
    data: data,
  });
}

// 修改员工
export function editStaff(data) {
  return request({
    url: '/staff/edit',
    method: 'post',
    data: data,
  });
}

// 删除员工
export function deleteStaff(data) {
  return request({
    url: '/staff/delete',
    method: 'post',
    data: data,
  });
}

// 密码修改
export function changePassword(data) {
  return request({
    url: '/user/changePassword',
    method: 'post',
    data: data,
  });
}

// 个人中心信息
export function userStaffInfo(query) {
  return request({
    url: '/user/info',
    method: 'GET',
    params: query,
  });
}

// 导入员工
export function importStaff(data) {
  return request({
    headers: {
      repeatSubmit: false,
    },
    url: '/staff/import',
    method: 'post',
    data: data,
  });
}

// 视频播放详情
export function playDetail(data) {
  return request({
    url: '/staff/playDetail',
    method: 'GET',
    params: data,
  })
}

// 登录信息，跟登录接口的返回值一样
export function loginInfo(query) {
  return request({
    url: '/user/loginInfo',
    method: 'GET',
    params: query,
  });
}

// 我下属的员工
export function mySubList(query) {
  return request({
    url: '/staff/mySubList',
    method: 'get',
    params: query,
  });
}

// 我下属的员工
export function mySublistTree(query) {
  return request({
    url: '/staff/mySublistTree',
    method: 'get',
    params: query,
  });
}

// 所有员工的id和姓名
export function idName(query) {
  return request({
    url: '/staff/idName',
    method: 'get',
    params: query,
  });
}

// 总的达成率
export function getTotalCompleteRateApi(query) {
  return request({
    url: '/staff/totalCompleteRate',
    method: 'get',
    params: query,
  });
}

// 分公司和项目
export function companyProject(query) {
  return request({
    url: '/staff/companyProject',
    method: 'get',
    params: query,
  });
}

// 获取任务的视频的id
export function getTaskPlanVideoIds(query) {
  return request({
    url: '/staff/getTaskPlanVideoIds',
    method: 'get',
    params: query,
  });
}


// 修改任务的视频的id
export function changeTaskPlanVideoIds(data) {
  return request({
    url: '/staff/changeTaskPlanVideoIds',
    method: 'post',
    data: data,
  });
}

// 是否需要电子签名
export function hasSignature(query) {
  return request({
    url: '/user/hasSignature',
    method: 'get',
    params: query,
  });
}

// 电子签名
export function userSignature(data) {
  return request({
    headers: {
      // 必须设置请求头，告知服务器请求体的类型
      'Content-Type': 'multipart/form-data',
    },
    url: '/user/signature',
    method: 'post',
    data: data,
  });
}